export default {
  detailOrAcceptCredit: {
    collapseTitle: {
      baseTitle: '收到信用证信息',
    },
    baseForm: {
      companyCode: '公司代码',
      companyPlaceholder: '请选择公司',
      departmentCode: '部门',
      departmentPlaceholder: '请选择部门',
      clCode: '信用证号',
      clCodePlaceholder: '请输入信用证号',
      clType: '信用证类别',
      clTypePlaceholder: '请选择信用证类别',
      clAmount: '信用证金额',
      clAmountPlaceholder: '请输入信用证金额',
      currencyCode: '币别',
      currencyPlaceholder: '请选择币别',
      branchCode: '开证行',
      bankPlaceholder: '请选择开证行',
      payBranchCode: '付款行',
      payBranchPlaceholder: '请选择付款行',
      notifyingBranchCode: '通知银行',
      notifyingBranchPlaceholder: '请选择通知银行',
      negotiationBranchCode: '议付行',
      negotiationBranchPlaceholder: '请选择议付行',
      statusFlag: '信用证状态',
      statusFlagPlaceholder: '自动生成',
      issueDate: '开证日期',
      issueDatePlaceholder: '请选择开证日期',
      receivingDate: '收到信用证日期',
      receivingDatePlaceholder: '请选择收到信用证日期',
      clAttr: '信用证属性',
      clAttrPlaceholder: '请选择信用证属性',
      overShortShippedPercentage: '溢短装比例/%',
      overShortShippedPercentagePlaceholder: '请输入溢短装比例',
      clValidDate: '有效期限',
      clValidDatePlaceholder: '请选择有效期限',
      partnerCode: '开证申请人',
      partnerCodePlaceholder: '请选择开证申请人',
      clNature: '信用证性质',
      clNaturePlaceholder: '请选择信用证性质',
      usanceDaysNumber: '远期天数',
      usanceDaysNumberPlaceholder: '请输入远期天数',
      latestShipDate: '最迟装期',
      latestShipDatePlaceholder: '请选择最迟装期',
      payCondition: '付款条件',
      payConditionPlaceholder: '请选择付款条件',
      acceptanceAmount: '已承兑金额',
      acceptanceAmountPlaceholder: '自动生成',
      paidAmount: '已收款金额',
      paidAmountPlaceholder: '自动生成',
      createBy: '创建人',
      createByPlaceholder: '自动生成',
      gmtCreate: '创建日期',
      gmtCreatePlaceholder: '自动生成',
      summary: '摘要',
      summaryPlaceholder: '请输入摘要',
    },
    goodsTable: {
      indexTitle: '序号',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      projectName: '项目',
      customerName: '客户',
      contractSalesmanName: '业务员',
      issueAmount: '认领金额',
      totalText: '小计',
    },
    goodsTableEditRules: {
      contractNo: '请选择合同号',
      issueAmount: '请输入认领金额',
    },
    acceptTable: {
      indexTitle: '序号',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      partnerName: '客户',
      acceptDate: '承兑日期',
      acceptAmount: '承兑金额',
      planPayDate: '计划收款日期',
      planPayAmount: '计划收款金额',
      remark: '备注',
      statusFlag: '状态',
      registerNo: '收款单号',
      voucherCode: '凭证编号',
      paidDate: '实际收款日期',
      paidAmount: '实际收款金额',
      receiveBankName: '收款银行账户名称',
      delayPaymentType: '部门公司押汇情况',
      delayPaymentType0: '不押汇',
      delayPaymentType1: '部门不押汇公司押汇',
      delayPaymentType2: '部门押汇公司不押汇',
      delayPaymentType3: '部门押汇且公司押汇',
      isLockExchangeRate: '是否锁汇',
    },
    acceptTableEditRules: {
      contractNo: '请选择合同号',
      acceptDate: '请选择承兑日期',
      acceptAmount: '请输入承兑金额',
      planPayDate: '请选择计划收款日期',
      planPayAmount: '请输入计划收款金额',
      remark: '请输入备注',
    },
    btnList: {
      save: '保存',
      submit: '确认承兑',
      add: '新增行',
      remove: '删除行',
      isAccpetComplete: '是否完全承兑',
      acceptCompleteDate: '完全承兑日期',
      isPayComplete: '是否完全收款',
    },
    tabsName: {
      contractDetail: '认领信息',
      acceptDetail: '承兑信息',
      negotiationDetail: '议付信息',
      delayPaymentDetail: '押汇信息',
      lockExchangeRateDetail: '锁汇信息',
    },
    msg: {
      selectTip: '请选择一条数据',
      saveSussess: '保存成功！',
      submitSusscess: '承兑成功！',
    },
  },
};
